import React from 'react'
import { Box } from "@mui/material";

import PartnerReports from '../../components/common/PartnerReports/PartnerReports'; 

const PartnerReportsGrid = ({ searchText, tableRef, apiRef, isCheckboxColumn, statusType, requestId, reportName }) => {
  return (
    <Box
        sx={{
            alignItems: "center",
            bgcolor: "#fff",
            py: 1.5
        }}
    >
        <PartnerReports 
          searchText={searchText}
          ref={tableRef}
          apiRef={apiRef}
          isCheckboxColumn={isCheckboxColumn}
          statusType={statusType}
          requestId={requestId}
          reportName={reportName}
      />
    </Box>
  )
}

export default PartnerReportsGrid